import { List } from '@material-ui/core/';
import { Admin } from '../../../store/types';
import useSelect from '../../../store/hooks/useSelect';
import PageItem from './PageItem';
import Loader from './Loader';

const styles = {
  width: '30vw',
  minWidth: '400px',
  height: 'calc(100vh - 49px)',
  bgcolor: 'background.paper',
  overflow: 'scroll',
  py: 0,
};

interface IProp {
  users: Admin[]
  loading?: boolean
}

export default ({ users, loading }: IProp) => {
  const { select } = useSelect();

  const PageItemsView = users.map((i) => <PageItem select={select} key={`${i.username}`} item={i} />);
  const ListView = <List sx={styles}>{PageItemsView}</List>;

  return loading ? <Loader /> : <>{ListView}</>;
};
